export async function Alert(title:string, text:string):Promise<void> {
  await DialogAlertConfirm(title, text, false);
}
export function Confirm(title:string, text:string):Promise<boolean> {
  return DialogAlertConfirm(title, text, true);
}

function DialogAlertConfirm(title:string, text:string, confirm:boolean):Promise<boolean> {
  let rv=false;
  let elMD=document.createElement("dialog");
  elMD.classList.add("modal");
  elMD.style.minWidth="300px"; //no larger than 300 for mobile!
  let el2=document.createElement("header");
  el2.innerText=title;
  elMD.appendChild(el2);
  el2=document.createElement("article");
  el2.innerText=text;
  elMD.appendChild(el2);
  el2=document.createElement("footer");
  elMD.appendChild(el2);
  let btnOK=document.createElement("button");
  btnOK.classList.add("primary");
  btnOK.setAttribute("type","button");
  btnOK.innerText="OK";
  btnOK.onclick=() => {elMD.close(); MyResolve(true);}
  el2.appendChild(btnOK);
  if(confirm) {
    let btnCancel=document.createElement("button");
    btnCancel.setAttribute("type","button");
    btnCancel.style.marginLeft=".5rem";
    btnCancel.innerText="Cancel";
    btnCancel.onclick=() => { elMD.close(); MyResolve(false);}
    el2.appendChild(btnCancel);
  }
  elMD.addEventListener("cancel",e=>{
    // escape key pressed
    if(!confirm) { e.preventDefault(); return }
    MyResolve(false);
  });
  elMD.addEventListener("close",e=>{
    elMD.remove();
  });
  document.body.appendChild(elMD);
  elMD.showModal();
  btnOK.focus();
  
  let MyResolve:(value:boolean)=>void;
  return new Promise((resolve, reject) => MyResolve=resolve);
}
